import { FIELD_TYPES } from "../../widgets/fields";

export const CommunicationSettingsElements = {
    token: {
        name: "token",
        placeholder: "Enter Token",
        label: "Token",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    phone_number_id: {
        name: "phone_number_id",
        placeholder: "Enter Whatsapp Number Id",
        label: "Whatsapp Number Id",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    template_id: {
        name: "template_id",
        placeholder: "Enter Template Id",
        label: "Template Id",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    }
};